import axios from 'axios'

const baseurl = `${import.meta.env.VITE_APP_PROTOCOL}://${import.meta.env.VITE_API_HOST}:${import.meta.env.VITE_API_PORT}/${import.meta.env.VITE_API_SUBPATH}`
const url = 'fwrs'

export const inUseFwAPI = async (fw_id: number) => {
  const response = await axios.get(`${baseurl}${url}`, {
    params: {
      cmd: 'inuse',
      fw_id: fw_id
    }
  })
  console.log("inUseFwAPI 응답:", response.data)
  return response.data.data
}
